import api from '@shared/services/api';

export const lengthOfServiceService = {
    getTblClassList: async () => {
        const response = await api.get('/tbl-class');
        return response.data;
    },

    getTblClassIdList: async () => {
        const response = await api.get('/tbl-class/list');
        return response.data;
    },

    getTblClassDetails: async ({ tblClassId, fromDate, catWorkId }) => {
        const params = new URLSearchParams();
        if (tblClassId != null && tblClassId !== '') {
            params.append('tblClassId', String(tblClassId));
        }
        if (fromDate) {
            params.append('fromDate', String(fromDate));
        }
        if (catWorkId != null && catWorkId !== '') {
            params.append('catWorkId', String(catWorkId));
        }
        const queryString = params.toString();
        const response = await api.get(`/tbl-class/details${queryString ? `?${queryString}` : ''}`);
        return response.data;
    },

    createTblClass: async (data) => {
        const response = await api.post('/tbl-class', data);
        return response.data;
    },

    createTblClassDetail: async (data) => {
        const response = await api.post('/tbl-class/details', data);
        return response.data;
    },

    updateTblClassDetailPercent: async (id, percent) => {
        const response = await api.patch(`/tbl-class/details/${id}`, { percent });
        return response.data;
    },

    updateTblClassActive: async (id, active) => {
        const params = new URLSearchParams();
        params.append('active', String(active === true || active === 'true'));
        const response = await api.patch(`/tbl-class/${id}?${params.toString()}`);
        return response.data;
    },

    deleteTblClass: async (id) => {
        const response = await api.delete(`/tbl-class/${id}`);
        return response.data;
    },
};
